import {
  GET_ALL_STATIONS_FAILURE,
  GET_ALL_STATIONS_SUCCESS,
  FETCH_ALL_STATIONS,
  GET_TASKS_FAILURE,
  GET_TASKS_SUCCESS,
  GET_MODULES_SUCCESS,
  GET_MODULES_FAILURE,
  FETCH_TASKS,
  GET_TASKS_DESCRIPTION_FAILURE,
  GET_TASKS_DESCRIPTION_SUCCESS,
  FETCH_TASKS_DESCRIPTION,
  FETCH_MODULES,
  ADD_TASK_DES,
  ADD_TASK_DES_FAILURE,
  ADD_TASK_DES_SUCCESS,
  UPDATE_TASK_DES,
  UPDATE_TASK_DES_FAILURE,
  UPDATE_TASK_DES_SUCCESS,
  GET_MODULES_AND_STATION_RATING_SUCCESS,
  GET_MODULES_AND_STATION_RATING_FAILURE,
  FETCH_MODULES_AND_STATION_RATING,
  GET_ALL_CHECK_UPDATES_SUCCESS,
  GET_ALL_CHECK_UPDATES_FAILURE,
  FETCH_ALL_CHECK_UPDATES,
} from "../constant";
import { Auth, API } from "aws-amplify";

const getAllStationsSuccess = (types) => {
  return {
    type: GET_ALL_STATIONS_SUCCESS,
    payload: {
      success: types.success,
      stations: types.message.data,
      dates: types.checkupDates,
    },
  };
};

const getAllStationsFailure = (error) => {
  return {
    type: GET_ALL_STATIONS_FAILURE,
    payload: { error },
  };
};

const fetchAllStations = () => {
  return {
    type: FETCH_ALL_STATIONS,
  };
};
const fetchAllCheckUpdates = () =>{
  return {
    type: FETCH_ALL_CHECK_UPDATES,
  }
}
const getAllCheckUpdatesSuccess = (types) =>{
  return{
    type: GET_ALL_CHECK_UPDATES_SUCCESS,
    payload: {
      success: types.success,
      dates: types.message.rows,
    }
  }
}

const getAllCheckUpdatesFailure = (error) =>{
  return {
    type: GET_ALL_CHECK_UPDATES_FAILURE,
    payload:{ error}
  }
}

export const getAllStations = (data) => {
  return async (dispatch) => {
    dispatch(fetchAllStations());
    API.get('AdminQueries', '/api/v1/getallstations', {
      queryStringParameters: data,
      headers: {
        Authorization: (await Auth.currentSession())
          .getAccessToken()
          .getJwtToken(),
      },
    })
      .then((res) => {
        dispatch(getAllStationsSuccess(res));
      })
      .catch((err) => {
        dispatch(
          getAllStationsFailure(
            err?.response?.data?.message
              ? err?.response?.data?.message
              : err.message
          )
        );
      });
  };
};
export const getAllCheckUpdates = (data) => {
  return async (dispatch) =>{
    dispatch(fetchAllCheckUpdates());
    API.get('AdminQueries','/api/v1/getallcheckupdates',{
      queryStringParameters: data,
      headers:{
        Authorization: (await Auth.currentSession())
        .getAccessToken()
        .getJwtToken(),
      },
    }).then((res)=>{
      dispatch(getAllCheckUpdatesSuccess(res))
    }).catch((err)=>{
      dispatch(getAllCheckUpdatesFailure(err));
    })
  }
}
const getModulesSuccess = (types) => {
  return {
    type: GET_MODULES_SUCCESS,
    payload: {
      success: types.success,
      modules: types.message.data ? types.message.data : [],
      message: types.message.data ? "" : types.message,
    },
  };
};

const getModulesFailure = (error) => {
  return {
    type: GET_MODULES_FAILURE,
    payload: { error },
  };
};
export const fetchModules = () => {
  return {
    type: FETCH_MODULES,
  };
};

export const getModules = (data) => {
  return async (dispatch) => {
    dispatch(fetchModules());
    API.get('AdminQueries', '/api/v1/getmodulesbystationid', {
      queryStringParameters: data,
      headers: {
        Authorization: (await Auth.currentSession())
          .getAccessToken()
          .getJwtToken(),
      },
    })
      .then((res) => {
        dispatch(getModulesSuccess(res));
      })
      .catch((err) => {
        dispatch(
          getModulesFailure(
            err?.response?.data?.message
              ? err?.response?.data?.message
              : err.message
          )
        );
      });
  };
};

const getTasksSuccess = (types) => {
  return {
    type: GET_TASKS_SUCCESS,
    payload: {
      success: types.success,
      tasks: types.message.data,
    },
  };
};

const getTasksFailure = (error) => {
  return {
    type: GET_TASKS_FAILURE,
    payload: { error },
  };
};

export const fetchTasks = () => {
  return {
    type: FETCH_TASKS,
  };
};

export const getTasks = (data) => {
  return async (dispatch) => {
    dispatch(fetchTasks());
    API.get('AdminQueries', '/api/v1/gettasksbymoduleid', {
      queryStringParameters: data,
      headers: {
        Authorization: (await Auth.currentSession())
          .getAccessToken()
          .getJwtToken(),
      },
    })
      .then((res) => {
        dispatch(getTasksSuccess(res));
      })
      .catch((err) => {
        dispatch(
          getTasksFailure(
            err?.response?.data?.message
              ? err?.response?.data?.message
              : err.message
          )
        );
      });
  };
};

const getTaskDesSuccess = (types) => {
  return {
    type: GET_TASKS_DESCRIPTION_SUCCESS,
    payload: {
      success: types.success,
      tasksDes: types.message.data,
    },
  };
};

const getTaskDesFailure = (error) => {
  return {
    type: GET_TASKS_DESCRIPTION_FAILURE,
    payload: { error },
  };
};

export const fetchTaskDes = () => {
  return {
    type: FETCH_TASKS_DESCRIPTION,
  };
};

export const getTaskDes = (data) => {
  return async (dispatch) => {
    dispatch(fetchTaskDes());
    API.get('UserQueries', '/api/v1/gettaskdescription', {
      queryStringParameters: data,
      headers: {
        Authorization: (await Auth.currentSession())
          .getAccessToken()
          .getJwtToken(),
      },
    })
      .then((res) => {
        dispatch(getTaskDesSuccess(res));
      })
      .catch((err) => {
        dispatch(
          getTaskDesFailure(
            err?.response?.data?.message
              ? err?.response?.data?.message
              : err.message
          )
        );
      });
  };
};

const addTaskDesSuccess = (types) => {
  return {
    type: ADD_TASK_DES_SUCCESS,
    payload: {
      success: types.success,
      message: types.message,
    },
  };
};

const addTaskDesFailure = (error) => {
  return {
    type: ADD_TASK_DES_FAILURE,
    payload: { error },
  };
};

const addtaskdes = () => {
  return {
    type: ADD_TASK_DES,
  };
};

export const addTaskDes = (data) => {
  return async (dispatch) => {
    dispatch(addtaskdes());
    API.post('AdminQueries', '/api/v1/addtaskdescription', {
      body: data,
      headers: {
        Authorization: (await Auth.currentSession())
          .getAccessToken()
          .getJwtToken(),
      },
    })
      .then((res) => {
        dispatch(addTaskDesSuccess(res));
      })
      .catch((err) => {
        dispatch(
          addTaskDesFailure(
            err?.response?.data?.message
              ? err?.response?.data?.message
              : err.message
          )
        );
      });
  };
};

const updateTaskDesSuccess = (types) => {
  return {
    type: UPDATE_TASK_DES_SUCCESS,
    payload: {
      success: types.success,
      message: types.message,
    },
  };
};

const updateTaskDesFailure = (error) => {
  return {
    type: UPDATE_TASK_DES_FAILURE,
    payload: { error },
  };
};

const updatetaskdes = () => {
  return {
    type: UPDATE_TASK_DES,
  };
};

export const updateTaskDes = (data) => {
  return async (dispatch) => {
    dispatch(updatetaskdes());
    API.put('AdminQueries', '/api/v1/updatetaskdescription', {
      body: data,
      headers: {
        Authorization: (await Auth.currentSession())
          .getAccessToken()
          .getJwtToken(),
      },
    })
      .then((res) => {
        dispatch(updateTaskDesSuccess(res));
      })
      .catch((err) => {
        dispatch(
          updateTaskDesFailure(
            err?.response?.data?.message
              ? err?.response?.data?.message
              : err.message
          )
        );
      });
  };
};

const getModulesAndStationRatingSuccess = (types) => {
  return {
    type: GET_MODULES_AND_STATION_RATING_SUCCESS,
    payload: {
      success: types.success,
      modRating: types.message.data,
      stationRating: types.TowerRating,
    },
  };
};

const getModulesAndStationRatingFailure = (error) => {
  return {
    type: GET_MODULES_AND_STATION_RATING_FAILURE,
    payload: { error },
  };
};
export const fetchModulesAndStationRating = () => {
  return {
    type: FETCH_MODULES_AND_STATION_RATING,
  };
};

export const getModulesAndStationRating = (data) => {
  return async (dispatch) => {
    dispatch(fetchModulesAndStationRating());
    API.get('AdminQueries', '/api/v1/getmodulesrating', {
      queryStringParameters: data,
      headers: {
        Authorization: (await Auth.currentSession())
          .getAccessToken()
          .getJwtToken(),
      },
    })
      .then((res) => {
        dispatch(getModulesAndStationRatingSuccess(res));
      })
      .catch((err) => {
        dispatch(
          getModulesAndStationRatingFailure(
            err?.response?.data?.message
              ? err?.response?.data?.message
              : err.message
          )
        );
      });
  };
};
